export default function () {
    let host = window.location.host;
    return 'https://bilaskra.is';
    // if(host == 'bilaskra.is' || host == 'www.bilaskra.is'){
    //     return 'https://bilaskra.is';
    // }

    // if(host == '1e09c06a9bb9951eb6fd65918031f520.bilaskra.is'){
    //     return 'https://1e09c06a9bb9951eb6fd65918031f520.bilaskra.is';
    // }

    // if(host == 'dev.bilaskra.is'){
    //     return 'https://dev.bilaskra.is';
    // }

    // if(host == 'dev2.bilaskra.is'){
    //     return 'https://dev2.bilaskra.is';
    // }

    // if (host.search("192.168") >= 0) {
    //     return 'http://dev2.bilaskra.is';
    // }
    // // return 'http://bilaskra-api.local';
    // return 'http://dev2.bilaskra.is';
}